
    import './styles.scoped.css';
    export default {
  "body-cell-counter": "awsui_body-cell-counter_10jtt_16x1t_5"
};
  